import dayjs, { Dayjs, isDayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { ChiroUpDayJsCommon } from '../constants/stringConstants';
import { SECONDS } from '../constants/time';
import { convertToMS } from './convertToMS';

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

export const timestamp = () => {
  return Date.now();
};

export const TIMEZONES = [
  { text: '(GMT-12:00) International Date Line West', value: 'Etc/GMT+12' },
  { text: '(GMT-11:00) American Samoa', value: 'Pacific/Pago_Pago' },
  { text: '(GMT-11:00) Midway Island', value: 'Pacific/Midway' },
  { text: '(GMT-10:00) Hawaii', value: 'Pacific/Honolulu' },
  { text: '(GMT-09:00) Alaska', value: 'America/Anchorage' },
  {
    text: '(GMT-08:00) Pacific Time (US & Canada)',
    value: 'America/Los_Angeles',
  },
  { text: '(GMT-08:00) Tijuana', value: 'America/Tijuana' },
  { text: '(GMT-07:00) Arizona', value: 'America/Phoenix' },
  { text: '(GMT-07:00) Mazatlan', value: 'America/Mazatlan' },
  { text: '(GMT-07:00) Mountain Time (US & Canada)', value: 'America/Denver' },
  { text: '(GMT-06:00) Central America', value: 'America/Guatemala' },
  { text: '(GMT-06:00) Central Time (US & Canada)', value: 'America/Chicago' },
  { text: '(GMT-06:00) Chihuahua', value: 'America/Chihuahua' },
  { text: '(GMT-06:00) Guadalajara', value: 'America/Guadalajara' },
  { text: '(GMT-06:00) Mexico City', value: 'America/Mexico_City' },
  { text: '(GMT-06:00) Monterrey', value: 'America/Monterrey' },
  { text: '(GMT-06:00) Saskatchewan', value: 'America/Regina' },
  { text: '(GMT-05:00) Bogota', value: 'America/Bogota' },
  { text: '(GMT-05:00) Eastern Time (US & Canada)', value: 'America/New_York' },
  { text: '(GMT-05:00) Indiana (East)', value: 'America/Indiana/Indianapolis' },
  { text: '(GMT-05:00) Lima', value: 'America/Lima' },
  { text: '(GMT-05:00) Quito', value: 'America/Guayaquil' },
  { text: '(GMT-04:00) Atlantic Time (Canada)', value: 'America/Halifax' },
  { text: '(GMT-04:00) Caracas', value: 'America/Caracas' },
  { text: '(GMT-04:00) Georgetown', value: 'America/Guyana' },
  { text: '(GMT-04:00) La Paz', value: 'America/La_Paz' },
  { text: '(GMT-04:00) Puerto Rico', value: 'America/Puerto_Rico' },
  { text: '(GMT-04:00) Santiago', value: 'America/Santiago' },
  { text: '(GMT-03:30) Newfoundland', value: 'America/St_Johns' },
  { text: '(GMT-03:00) Brasilia', value: 'America/Sao_Paulo' },
  { text: '(GMT-03:00) Buenos Aires', value: 'America/Argentina/Buenos_Aires' },
  { text: '(GMT-03:00) Montevideo', value: 'America/Montevideo' },
  { text: '(GMT-03:00) Santiago', value: 'America/Santiago' },
  { text: '(GMT-02:00) Brasilia', value: 'America/Sao_Paulo' },
  { text: '(GMT-02:00) Mid-Atlantic', value: 'Etc/GMT+2' },
  { text: '(GMT-01:00) Azores', value: 'Atlantic/Azores' },
  { text: '(GMT-01:00) Cape Verde Is.', value: 'Atlantic/Cape_Verde' },
  { text: '(GMT+00:00) Casablanca', value: 'Africa/Casablanca' },
  {
    text: '(GMT+00:00) Dublin, Edinburgh, Lisbon, London',
    value: 'Europe/London',
  },
  {
    text: '(GMT+00:00) Greenwich Mean Time : Monrovia, Reykjavik',
    value: 'Etc/GMT',
  },
  {
    text: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'Europe/Berlin',
  },
  {
    text: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    value: 'Europe/Budapest',
  },
  {
    text: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
    value: 'Europe/Paris',
  },
  {
    text: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    value: 'Europe/Warsaw',
  },
  { text: '(GMT+01:00) West Central Africa', value: 'Africa/Lagos' },
  { text: '(GMT+02:00) Athens, Bucharest', value: 'Europe/Athens' },
  { text: '(GMT+02:00) Cairo', value: 'Africa/Cairo' },
  { text: '(GMT+02:00) Harare, Pretoria', value: 'Africa/Johannesburg' },
  {
    text: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    value: 'Europe/Helsinki',
  },
  { text: '(GMT+02:00) Istanbul', value: 'Europe/Istanbul' },
  { text: '(GMT+02:00) Jerusalem', value: 'Asia/Jerusalem' },
  { text: '(GMT+03:00) Baghdad', value: 'Asia/Baghdad' },
  { text: '(GMT+03:00) Kuwait, Riyadh', value: 'Asia/Riyadh' },
  { text: '(GMT+03:00) Minsk', value: 'Europe/Minsk' },
  {
    text: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
    value: 'Europe/Moscow',
  },
  { text: '(GMT+03:00) Nairobi', value: 'Africa/Nairobi' },
  { text: '(GMT+03:30) Tehran', value: 'Asia/Tehran' },
  { text: '(GMT+04:00) Abu Dhabi, Muscat', value: 'Asia/Dubai' },
  { text: '(GMT+04:00) Baku', value: 'Asia/Baku' },
  { text: '(GMT+04:00) Caucasus Standard Time', value: 'Asia/Yerevan' },
  { text: '(GMT+04:00) Port Louis', value: 'Indian/Mauritius' },
  { text: '(GMT+04:00) Tbilisi', value: 'Asia/Tbilisi' },
  { text: '(GMT+04:00) Yerevan', value: 'Asia/Yerevan' },
  { text: '(GMT+04:30) Kabul', value: 'Asia/Kabul' },
  { text: '(GMT+05:00) Ekaterinburg', value: 'Asia/Yekaterinburg' },
  { text: '(GMT+05:00) Islamabad, Karachi', value: 'Asia/Karachi' },
  { text: '(GMT+05:00) Tashkent', value: 'Asia/Tashkent' },
  {
    text: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'Asia/Kolkata',
  },
  { text: '(GMT+05:30) Sri Jayawardenepura', value: 'Asia/Colombo' },
  { text: '(GMT+05:45) Kathmandu', value: 'Asia/Kathmandu' },
  { text: '(GMT+06:00) Almaty, Novosibirsk', value: 'Asia/Almaty' },
  { text: '(GMT+06:00) Astana, Dhaka', value: 'Asia/Dhaka' },
  { text: '(GMT+06:30) Yangon (Rangoon)', value: 'Asia/Rangoon' },
  { text: '(GMT+07:00) Bangkok, Hanoi, Jakarta', value: 'Asia/Bangkok' },
  { text: '(GMT+07:00) Krasnoyarsk', value: 'Asia/Krasnoyarsk' },
  {
    text: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    value: 'Asia/Shanghai',
  },
  { text: '(GMT+08:00) Irkutsk, Ulaan Bataar', value: 'Asia/Irkutsk' },
  { text: '(GMT+08:00) Kuala Lumpur, Singapore', value: 'Asia/Singapore' },
  { text: '(GMT+08:00) Perth', value: 'Australia/Perth' },
  { text: '(GMT+08:00) Taipei', value: 'Asia/Taipei' },
  { text: '(GMT+09:00) Osaka, Sapporo, Tokyo', value: 'Asia/Tokyo' },
  { text: '(GMT+09:00) Seoul', value: 'Asia/Seoul' },
  { text: '(GMT+09:00) Yakutsk', value: 'Asia/Yakutsk' },
  { text: '(GMT+09:30) Adelaide', value: 'Australia/Adelaide' },
  { text: '(GMT+09:30) Darwin', value: 'Australia/Darwin' },
  { text: '(GMT+10:00) Brisbane', value: 'Australia/Brisbane' },
  {
    text: '(GMT+10:00) Canberra, Melbourne, Sydney',
    value: 'Australia/Sydney',
  },
  { text: '(GMT+10:00) Guam, Port Moresby', value: 'Pacific/Guam' },
  { text: '(GMT+10:00) Hobart', value: 'Australia/Hobart' },
  { text: '(GMT+10:00) Vladivostok', value: 'Asia/Vladivostok' },
  {
    text: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
    value: 'Asia/Magadan',
  },
  { text: '(GMT+12:00) Auckland, Wellington', value: 'Pacific/Auckland' },
  { text: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.', value: 'Pacific/Fiji' },
  { text: "(GMT+13:00) Nuku'alofa", value: 'Pacific/Tongatapu' },
  { text: '(GMT+13:00) Samoa', value: 'Pacific/Apia' },
];

export const createDayjs = ({
  datetime,
  timezone,
  neverNull = false,
}: {
  datetime: string | number | Dayjs;
  timezone: string;
  neverNull?: boolean;
}): Dayjs | null => {
  if (!datetime || !timezone) return null;
  if (typeof datetime === 'object') return datetime;
  const dayjsDatetime = dayjs.tz(datetime, timezone);
  if (!dayjsDatetime.isValid()) return neverNull ? dayjs().tz(timezone) : null;

  return dayjsDatetime === null && neverNull ? dayjs().tz(timezone) : dayjsDatetime;
};

export const createNeverNullDayjs = ({
  datetime,
  timezone = ChiroUpDayJsCommon.defaultTimezone,
}: {
  datetime: any;
  timezone?: string;
}): Dayjs => {
  if (isDayjs(datetime)) return datetime;
  if (!timezone) timezone = ChiroUpDayJsCommon.defaultTimezone;
  const defaultResponse = dayjs(Date.now()).tz(timezone);

  try {
    if (!datetime) return defaultResponse;

    const dayjsDatetime = dayjs.tz(datetime, timezone);
    if (!dayjsDatetime || !dayjsDatetime.isValid) return defaultResponse;
    if (!dayjsDatetime.isValid()) return defaultResponse;

    return dayjsDatetime;
  } catch (e: any) {
    console.error(e);

    return defaultResponse;
  }
};

export const formatStatementDate = (dt: string | number, timezone?: string): string =>
  timezone ? dayjs.utc(dt).tz(timezone).format('MM/DD/YYYY') : dayjs.utc(dt).format('MM/DD/YYYY');

export const formatStatementPaymentDate = (dt: string | number, timezone?: string): string => {
  // For payment dates, treat them as date-only values without timezone conversion
  if (!dt) return '';

  try {
    const utcDate = dayjs.utc(dt);

    return utcDate.format('MM/DD/YYYY');
  } catch (e) {
    console.warn('formatStatementPaymentDate: Error formatting date:', dt, e);

    return formatStatementDate(dt, timezone);
  }
};

export const createUTCDayjs = (date?: string | number): Dayjs => {
  return date ? dayjs.utc(date) : dayjs.utc();
};

export const createUTCTimestampForDB = (date?: string): number => {
  return dayjs.utc(date).valueOf();
};

export const convertDayjsToUTC = ({ datetime }: { datetime: Dayjs | number }): number | null => {
  if (typeof datetime === 'number') {
    datetime = dayjs.utc(datetime);
  }

  try {
    if (typeof datetime === 'string') {
      datetime = dayjs.utc(datetime);
    }
  } catch (e) {
    console.error(e);
    // return null;
  }

  if (!isDayjs(datetime)) return null;
  if (!datetime?.isValid()) return null;

  // If it gets here, it should already be in the timezone we care about
  return datetime.utc().valueOf();
};

export const convertToUTC = ({
  datetime,
  timezone,
}: {
  datetime: string;
  timezone: string;
}): number | null => {
  if (!datetime || !timezone) return null;

  const dayjsDatetime = dayjs.tz(datetime, timezone);
  if (!dayjsDatetime.isValid()) return null;

  return dayjsDatetime.utc().valueOf();
};

export const convertFromUTC = ({
  datetime,
  timezone = 'UTC',
}: {
  datetime: number | string | Dayjs;
  timezone?: string;
}): Dayjs | null => {
  if (!datetime) return null;
  if (!timezone) return null;

  if (typeof datetime === 'number') {
    const convertedTime = convertToMS(datetime);
    datetime = dayjs.utc(convertedTime);
  } else if (typeof datetime === 'string') {
    datetime = dayjs.utc(datetime);
  }

  if (!datetime.isValid()) return null;

  return datetime.tz(timezone);
};

const convertFromUTCToString = ({
  datetime,
  timezone,
}: {
  datetime: number | string | Dayjs;
  timezone: string;
}): string | null => {
  const converted = convertFromUTC({ datetime, timezone });
  if (!converted) return null;

  return converted.format('YYYY-MM-DDTHH:mm:ss');
};

export const convertUTCToFormattedDate = ({
  datetime,
  timezone,
}: {
  datetime: number | string | Dayjs;
  timezone: string;
}): string | null => {
  const converted = convertFromUTC({ datetime, timezone });
  if (!converted) return null;

  return converted.format(ChiroUpDayJsCommon.format.datetime);
};

export const convertUTCTommddyyyy = ({
  datetime,
  timezone,
}: {
  datetime: number | string | Dayjs;
  timezone: string;
}): string | null => {
  const converted = convertFromUTC({ datetime, timezone });
  if (!converted) return null;

  return converted.format(ChiroUpDayJsCommon.format.mmddyyyy);
};

/**
 * MM/DD/YYYY (or M/D/YYYY) → epoch ms at UTC midnight, the encoding of the generated
 * `Era.remitDate`; null when the input isn't such a date. The inverse is
 * `convertUTCTommddyyyy({ datetime, timezone: 'UTC' })`.
 */
export function parseMmDdYyyyToUtcMs(input?: string | null): number | null {
  const s = String(input ?? '').trim();
  const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return null;
  const month = Number(m[1]);
  const day = Number(m[2]);
  const year = Number(m[3]);
  if (!year || month < 1 || month > 12 || day < 1 || day > 31) return null;

  return Date.UTC(year, month - 1, day, 0, 0, 0, 0);
}

/**
 * Formats a date to ISO 8601 UTC format (YYYY-MM-DDTHH:mm:ssZ)
 * @param date - The date to format (can be Date, string, number, or Dayjs object)
 * @returns Formatted date string in ISO 8601 UTC format
 */
export const formatToISO8601UTC = (date?: Date | string | number | Dayjs): string => {
  return dayjs.utc(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
};

/**
 * Parses an ISO 8601 UTC string and returns a Dayjs object in UTC
 * @param isoString - The ISO 8601 string to parse
 * @returns Dayjs object in UTC timezone
 */
const parseISO8601UTC = (isoString: string): Dayjs => {
  return dayjs.utc(isoString);
};

/**
 * Validates if a string is in ISO 8601 UTC format (YYYY-MM-DDTHH:mm:ssZ)
 * @param dateString - The string to validate
 * @returns Boolean indicating if the string is valid ISO 8601 UTC
 */
export const isValidISO8601UTC = (dateString: string): boolean => {
  if (!dateString) return false;

  // Check basic format with regex
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
  if (!isoDateRegex.test(dateString)) return false;

  // Check if it's a valid date
  const date = dayjs.utc(dateString);

  return date.isValid();
};

/**
 * Converts a MySQL datetime format to ISO 8601 UTC format
 * @param mysqlDatetime - MySQL datetime string (YYYY-MM-DD HH:mm:ss)
 * @returns ISO 8601 UTC formatted string
 */
export const mysqlDatetimeToISO8601UTC = (mysqlDatetime: string): string => {
  return dayjs.utc(mysqlDatetime).format('YYYY-MM-DDTHH:mm:ss[Z]');
};

/**
 * Converts an ISO 8601 UTC string to MySQL datetime format
 * @param isoString - ISO 8601 UTC string
 * @returns MySQL datetime formatted string (YYYY-MM-DD HH:mm:ss)
 */
export const iso8601UTCToMySQLDatetime = (isoString: string): string => {
  return dayjs.utc(isoString).format('YYYY-MM-DD HH:mm:ss');
};

export const startTimeToTransactionDate = ({
  startTime,
  // timezone,
}: {
  startTime: number;
  timezone: string;
}) => {
  return startTime;
  // const d = dayjs(startTime).tz(timezone).toDate();
  // return new Date(
  //   `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} 00:00:00`,
  // ).getTime();
};

const getUtcOffsetString = () => {
  const date = new Date();
  const offsetMinutes = date.getTimezoneOffset(); // Returns offset in minutes (positive if behind UTC, negative if ahead)

  // Determine the sign and convert to hours and remaining minutes
  const sign = offsetMinutes > 0 ? '-' : '+'; // Invert sign for display (e.g., -360 minutes becomes +06:00)
  const absOffsetMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absOffsetMinutes / 60);
  const minutes = absOffsetMinutes % 60;

  // Format hours and minutes to always have two digits
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');

  return `GMT${sign}${formattedHours}:${formattedMinutes}`;
};

const getUtcOffsetName = () => {
  const offsetString = getUtcOffsetString();
  const found = TIMEZONES.find(tz => tz.text.indexOf(offsetString) !== -1);

  return found?.value || offsetString;
};

export const NORMALIZED_DATE_FORMATS = ['MM/DD/YYYY', 'M/D/YYYY', 'YYYYMMDD', 'YYYY-MM-DD'];

/**
 * Normalizes a date string from various formats to YYYY-MM-DD (ISO date).
 * Useful when comparing against MySQL DATE() output, e.g. matching a service
 * date from an 835 against PatientTransaction.transactionDate (bigint ms).
 *
 * @param dateStr - Date string in MM/DD/YYYY, YYYYMMDD, or YYYY-MM-DD format
 * @returns Date formatted as YYYY-MM-DD, or undefined if invalid/missing
 *
 * @example
 * normalizeToFormat('01/29/2026', <format>) // '2026-01-29'
 * normalizeToFormat('20260129', <format>)   // '2026-01-29'
 * normalizeToFormat('2026-01-29', <format>) // '2026-01-29'
 * normalizeToFormat('20261301', <format>)   // undefined
 * normalizeToFormat(null, <format>)         // undefined
 */
export function normalizeDateStringToFormat(
  dateStr: string | undefined | null,
  format: string
): string | undefined {
  if (!dateStr) return undefined;

  const parsed = dayjs(dateStr, NORMALIZED_DATE_FORMATS, true);

  if (!parsed.isValid()) {
    return undefined; // Garbage of some kind we don't want to handle.
  }

  return parsed.format(format);
}

export function normalizeDateToYYYYMMDD(dateStr: string | undefined | null): string {
  return normalizeDateStringToFormat(dateStr, 'YYYYMMDD') || 'UNKNOWN';
}

export function normalizeDateToMmDdYyyy(dateStr: string | undefined | null): string | undefined {
  return normalizeDateStringToFormat(dateStr, 'MM/DD/YYYY');
}

export function normalizeDateToISODate(dateStr: string | undefined | null): string | undefined {
  return normalizeDateStringToFormat(dateStr, 'YYYY-MM-DD');
}

export const DAY_START = '00:00:00';
export const DAY_END = '23:59:59';

// `HH:mm:ss` (a MySQL TIME) to seconds since midnight, and back.
export const timeOfDayToSeconds = (time: string): number => {
  const [hours, minutes, seconds] = time.split(':').map(Number);

  return SECONDS.inHours(hours) + SECONDS.inMinutes(minutes) + (seconds || 0);
};

export const secondsToTimeOfDay = (totalSeconds: number): string =>
  [
    Math.floor(totalSeconds / SECONDS.HOUR),
    Math.floor((totalSeconds % SECONDS.HOUR) / SECONDS.MINUTE),
    totalSeconds % SECONDS.MINUTE,
  ]
    .map(part => String(part).padStart(2, '0'))
    .join(':');
